import React from 'react';
import { Text } from '../../atoms/Text';
import { List } from '../../atoms/List';

export interface MenuSectionProps {
  /**
   * Section heading text
   */
  title: string;
  /**
   * Menu items (should be MenuItem components)
   */
  children: React.ReactNode;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * HTML id attribute
   */
  id?: string;
}

export const MenuSection: React.FC<MenuSectionProps> = ({
  title,
  children,
  className = '',
  id,
}) => {
  const baseClass = 'hi-ui hi-ui-menu-section';
  const allClasses = `${baseClass} ${className}`.trim();

  return (
    <div className={allClasses} id={id}>
      <Text variant="heading-2" className="hi-ui-menu-section-title">
        {title}
      </Text>
      <List className="hi-ui-menu-section-list home-lfeatures">{children}</List>
    </div>
  );
};
